import PropertyReviewNotification from "./PropertyReviewNotification";

const NotificationComponents = {
    property_review: PropertyReviewNotification,
};

export default NotificationComponents;
